import React from 'react';
import './MoveBar.css';

// The bar shown at the bottom of the screen while moving things.
function MoveBar({ count, allSelected, onToggleAll, destinationLabel, onChooseDestination, onMove, onCancel, busy, error }) {
  return (
    <div className="move-bar">
      {error && <p className="move-bar-error">{error}</p>}
      <div className="move-bar-row">
        <span className="move-bar-count">{count} selected</span>
        <button type="button" className="move-bar-link" onClick={onToggleAll}>
          {allSelected ? 'Clear' : 'Select all'}
        </button>
      </div>
      <div className="move-bar-row">
        <button type="button" className="btn btn-secondary" onClick={onChooseDestination} disabled={busy}>
          {destinationLabel ? `To: ${destinationLabel}` : 'Choose destination...'}
        </button>
      </div>
      <div className="move-bar-row move-bar-actions">
        <button type="button" className="btn btn-secondary" onClick={onCancel} disabled={busy}>
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={onMove}
          disabled={busy || count === 0 || destinationLabel === null}
        >
          {busy ? 'Moving...' : 'Move here'}
        </button>
      </div>
    </div>
  );
}

export default MoveBar;
